<div class="form-group">
	<label class="control-label col-sm-3">Rechercher les arr&ecirc;ts possibles sur : </label>
	<div class="col-sm-3">
		<label class="radio-inline" *ngFor="let option of dureeOptions; let index = index">
			<input type="radio"
				name="choixDuree"
				[id]="'choixDuree_' + index"
				[value]="option.value"
				required
				[(ngModel)]="choixDuree"
				(ngModelChange)="choixDureeSubject.next($event)"
			/>
			{{ option.label }}
		</label>
	</div>
	
	<label class="control-label col-sm-3">Type d'arrets : </label>
	<div class="col-sm-3">
		<checkbox-list
			[id]="'typeArretID'"
			[wildcardOptionLabel]="'Tous'"
			[itemList]="typeArretOptions"
			[labelGetter]="getTypeArretLabel"
			[preselectionFunction]="typeArretShouldBeSelectedByDefaut"
			(selectedItemsChange)="onTypeArretSelectionChanged($event)"
			>
		</checkbox-list>
	
	</div>
</div>
<div class="text-center">
	<table width="100%" class="table table-striped table-bordered table-hover" id="dataTableArrets">
		<thead>
			<tr>
				<th class="text-center">Ouvrage</th>
				<th class="text-center">D&eacute;but</th>
				<th class="text-center">Fin</th>
				<th class="text-center">Dur&eacute;e (min)</th>
				<th class="text-center">Type</th>
				<th class="text-center" width="25%">Description</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngIf="arretsOuvrageLoading">
				<td colspan="6"><i>Recherche en cours...</i></td>
			</tr>
			<ng-container *ngIf="!arretsOuvrageLoading && !arretsOuvrageLoadingError">
				<tr *ngFor="let arretOuvrage of arretsOuvrage | filterWithCallback : keepOnlyChosenTypes : typeArretSelected; let index = index;">
					<td>{{ ouvrages[0].nom }}</td>
					<td>{{ arretOuvrage.start | date : "dd/MM/yyyy HH:mm" }}</td>
					<td>{{ arretOuvrage.end | date : "dd/MM/yyyy HH:mm" }}</td>
					<td>{{ arretOuvrage.entity.duration }}</td>
					<td>{{ arretOuvrage.entity.statusCode }}</td>
					<td><p class="commentaire">{{ arretOuvrage.entity.statusCodeOrigin }}</p></td>
					<td>
					<button type="button" class="btn btn-xs btn-success"
						[disabled]="arretsOuvrageSelectedMap.get(arretOuvrage.entity.uid) || arretsOuvrageAssociatedMap.get(arretOuvrage.entity.uid)"
						[title]="getAssociationTooltip(arretOuvrage.entity.uid)"
						(click)="addArret(arretOuvrage)">Ajouter</button>
					</td>

				</tr>
				<tr *ngIf="!arretsOuvrage || arretsOuvrage.length === 0">
					<td colspan="7" class="alert alert-danger text-center">
						Aucun arr&ecirc;t trouv&eacute; sur cette p&eacute;riode
					</td>
				</tr>
			</ng-container>
			<tr *ngIf="!arretsOuvrageLoading && arretsOuvrageLoadingError">
				<td colspan="7" class="alert alert-danger">
					<b>Erreur(s) :</b>
					<p>{{ arretsOuvrageLoadingError }}</p>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<div class="form-group">
	<label for="commentArret" class="col-sm-4 control-label">
		S&eacute;lectionnez au moins un arr&ecirc;t, ou saisissez un commentaire :
	</label>
	<div class="col-sm-8">
		<textarea
			class="form-control"
			type="text"
			id="commentArret"
			name="commentArret" 
			[attr.disabled]="commentaireArretsDisabled ? 'disabled' : null"
			[(ngModel)]="commentaireArrets"
			(ngModelChange)="commentaireArretsChange.emit($event)">
		</textarea>
	</div>
</div>
<h3>Arr&ecirc;ts s&eacute;lectionn&eacute;s&nbsp;:</h3>
<div class="text-center">
	<table width="100%" class="table table-striped table-bordered" id="dataTableSelectedArrets">
		<thead>
			<tr>
				<th class="text-center">Ouvrage</th>
				<th class="text-center">D&eacute;but</th>
				<th class="text-center">Fin</th>
				<th class="text-center">Dur&eacute;e (min)</th>
				<th class="text-center">Type</th>
				<th class="text-center" width="25%">Description</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let arretAcces of arretsAcces; let index = index;">
				<tr [style.color]="arretAcces.actualized? null : 'red'">
					<td>{{ ouvrages[0].nom }}</td>
					<td>{{ arretAcces.start | date : "dd/MM/yyyy HH:mm" }}</td>
					<td>{{ arretAcces.end | date : "dd/MM/yyyy HH:mm" }}</td>
					<td>{{ arretAcces.entity.duration }}</td>
					<td>{{ arretAcces.entity.statusCode }}</td>
					<td><p class="commentaire">{{ arretAcces.entity.statusCodeOrigin }}</p></td>
					<td>
						<button type="button" class="btn btn-xs btn-danger" (click)="removeArret(index)">Supprimer</button>
					</td>
				</tr>
			</ng-container>
			<tr *ngIf="!arretsAcces || arretsAcces.length === 0">
				<td colspan="7">
					<i>Aucun arr&ecirc;t s&eacute;lectionn&eacute;</i>
				</td>
			</tr>
			<tr *ngIf="hasNonActualizedArretsAcces">
				<td colspan="7">
					<i>Les arr&ecirc;ts list&eacute;s en rouge n'ont pas pu &ecirc;tre actualis&eacute;s &agrave; partir des donn&eacute;es de Darwin.</i>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<div class="form-group">
	<label for="commentArret" class="col-sm-4 control-label">
		Indiquer qu'il n'y a pas d'arrêt associable :
	</label>
	<div class="checkboxLabel col-sm-8">
		<input name="signalerNoArretsCheckbox" type="checkbox" [(ngModel)]="signalerNoArretsCheckbox" (ngModelChange)="signalerNoArrets($event)" [disabled]="arretsAcces && arretsAcces.length > 0">
	</div>
</div>
